<script setup>
import DataFilterComponent from './DataFilterComponent.vue'

defineProps({
  filter: Object,
  placement: { default: 'bottom' },
  offset: { default: 8 },
  shift: { default: 16 },
  position: Object,
})

const emit = defineEmits(['open', 'close', 'apply'])

const isOpen = ref(false)

watch(isOpen, (isOpen) => {
  if (isOpen)
    emit('open')
  else emit('close')
})
</script>

<template>
  <div class="data-filter-popup">
    <DSPopup
      :placement="placement"
      :offset="offset"
      :shift="shift"
      :position="position"
      match-width
      enter="transition duration-100 ease-out"
      enter-from="transform scale-95 opacity-0"
      enter-to="transform scale-100 opacity-100"
      leave="transition duration-75 ease-out"
      leave-from="transform scale-100 opacity-100"
      leave-to="transform scale-95 opacity-0"
      class="!block"
      @open="isOpen = true"
      @close="isOpen = false"
    >
      <slot />
      <template #content="{ close }">
        <div
          class="data-filter-component-popup min-w-240px rounded-8px bg-white shadow-xl ring-1 ring-surface-700"
        >
          <DataFilterComponent
            v-bind="{ ...filter, isOpen, close }"
            @apply="$emit('apply')"
          />
        </div>
      </template>
    </DSPopup>
  </div>
</template>

<style scoped lang="scss">
.data-filter-popup {
  // two extra divs are for onclickoutside and getelementbounding divs in basepopup.  this is hacky, but we need to exclude deeper children
  > :deep(div) > div > .base-popup {
    > div:nth-child(2) {
      @apply lt-md:w-full;
    }
  }
}
</style>
